<template>
	<div>
		<Loader :show="loading" type="inline" />

		<div class="d-flex justify-content-end">
			<div class="btn btn-primary" @click="open()">Agregar ubicación</div>
		</div>

		<table class="table table-clickeable" v-if="!loading">
			<tr class="table-head">
				<td>Nombre</td>

				<td></td>
			</tr>

			<tr v-for="item of list" :key="item.id" @click="open(item)">
				<td>
					<div class="tc">
						<span class="bolder">{{ item.name }}</span>
					</div>
				</td>
				<td>
					<div class="tc">
						<span class="bolder">{{ item.address }}</span>
						<span>{{ item.locality.name }} {{ item.locality.region.name }}</span>
					</div>
				</td>
			</tr>
		</table>

		<div class="alert alert-default text-center mt-3" v-if="!loading && list.length == 0">
			No se han encontrado ubicaciones
		</div>

		<b-modal id="locationModal" :title="title" no-close-on-backdrop hide-footer>
			<Loader :show="saving" />

			<FormulateForm v-if="!loading" v-model="form" ref="form" @submit="save">
				<FormulateInput
					label="Nombre del lugar"
					name="name"
					type="suggest"
					:options="locations"
					validation-name="Nombre del lugar"
					validation="required"
					@selected="onLocationSelected"
					iconList="icon icon-clock"
					keyValue="id"
					keyLabel="name"
					mode="input"
				/>

				<FormulateInput
					label="Departamento"
					name="region"
					type="selectSearch"
					:options="regions"
					validation-name="Departamento"
					validation="required"
					@selected="onRegionSelected"
					optionValue="id"
					optionText="name"
				/>

				<FormulateInput
					label="Ciudad"
					name="locality"
					type="selectSearch"
					:options="localitiesFiltered"
					validation-name="Ciudad"
					validation="required"
					@selected="$emit('changed', form)"
					optionValue="id"
					optionText="name"
				/>

				<FormulateInput
					label="Dirección"
					name="address"
					type="text"
					validation-name="Dirección"
					validation="required"
					@input="$emit('changed', form)"
				/>

				<FormulateInput
					type="latlng"
					label="Ubicación"
					name="latlng"
					validation-name="Ubicación"
					validation="required"
					@input="$emit('changed', form)"
				/>

				<hr />

				<div class="d-flex justify-content-between mt-4">
					<FormulateInput type="button" data-ghost @click="close">Cancelar</FormulateInput>
					<FormulateInput type="button" disabled v-if="saving"
						>Guardando <span class="loader"
					/></FormulateInput>
					<FormulateInput type="submit" label="Guardar" v-else />
				</div>
			</FormulateForm>
		</b-modal>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Locations",

	props: {
		canCreate: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			list: [],
			loading: true,
			title: "Agregar ubicación",
			action: "create",
			form: {
				id: null,
				name: null,
				locality: null,
				region: null,
				address: null,
				latlng: null
			},
			locations: [],
			regions: []
		}
	},

	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	computed: {
		localitiesFiltered() {
			const regionSelected = this.form.region
				? this.regions.find((region) => region.id == this.form.region)
				: null

			return regionSelected ? regionSelected.localities : []
		}
	},

	methods: {
		onLocationSelected(location) {
			console.log("onLocationSelected", location)
			if (location && location.id) {
				this.form.location[0] = {
					id: location.id,
					name: location.name,
					region: location.locality.region.id,
					locality: location.locality.id,
					address: location.address,
					latlng: location.latlng
				}
			}
		},

		// selecciono un departamento, filtro las ciudades
		onRegionSelected() {
			this.form.location[0].locality = null
		},

		async open(item) {
			this.loading = true

			if (item) {
				this.title = "Editar cuenta bancaria"
				this.action = "update"
				console.log(item)
				this.form = {
					id: item.id,
					name: item.name,
					region: item.locality.region.id,
					locality: item.locality.id,
					address: item.address,
					latlng: item.latlng
				}
			} else {
				this.form = {
					id: null,
					name: null,
					locality: null,
					region: null,
					address: null,
					latlng: null
				}
			}

			this.$bvModal.show("locationModal")
			this.loading = false
		},
		close() {
			this.$bvModal.hide("locationModal")
			this.form = {
				id: null,
				name: null,
				locality: null,
				region: null,
				address: null,
				latlng: null
			}
		},
		async save() {
			if (!this.saving) {
				this.saving = true
				let data = {
					name: this.form.name,
					locality: this.form.locality,
					address: this.form.address,
					latlng: this.form.latlng ? { lat: this.form.latlng.lat, lng: this.form.latlng.lng } : null
				}

				if (this.action == "create") await this.create(data)
				if (this.action == "update") await this.update(data)
				this.load()
				this.saving = false
			}
		},

		async create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: EventLocationInput!) {
							eventLocationCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Ubicación creada correctamente")
					this.close()
					return data.eventLocationCreate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		async update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: EventLocationInput!) {
							eventLocationUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.form.id,
						data
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.$toast.success("Ubicación editada correctamente")
					this.close()
					return data.eventLocationUpdate
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.saving = false
				})
		},

		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							eventLocations(take: $take, skip: $skip, search: $search) {
								data {
									id
									name
									locality {
										id
										name
										region {
											id
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								pageInfo {
									totalItems
								}
							}
							regions {
								id
								name
								localities {
									id
									name
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.list = data.eventLocations.data
					this.pagination.pageInfo = data.eventLocations.pageInfo
					this.regions = data.regions

					this.loading = false
				})
		}

		// deletePrompt(item) {
		// 	this.$dialog.confirm("¿Está seguro que desea eliminar este item?").then(() => {
		// 		this.delete(item)
		// 	})
		// },

		// delete(item) {
		// 	item.loading = true
		// 	this.$apollo
		// 		.mutate({
		// 			mutation: gql`
		// 				mutation($id: ID!) {
		// 					bankAccountDelete(id: $id) {
		// 						id
		// 					}
		// 				}
		// 			`,
		// 			variables: {
		// 				id: item.id
		// 			}
		// 		})
		// 		.then(() => {
		// 			this.$toast.success("Elemento eliminado correctamente")
		// 			this.load()
		// 		})
		// 		.catch((error) => {
		// 			this.errors = this.parseGQLErrors(error)
		// 			item.loading = false
		// 		})
		// }
	}
}
</script>

<style scoped lang="scss">
.item {
	padding: 8px 12px;
	border-bottom: 1px solid #f3f3f3;
	cursor: pointer;
	border-radius: 4px;
	margin-top: 4px;

	h5 {
		font-size: 1.1rem;
		font-weight: 500;
		margin: 0px;
	}

	p {
		font-size: 0.85rem;
		line-height: 0.9rem;
		color: #999;
		margin: 0px;
		font-weight: 300;
	}

	&:hover {
		background-color: #f3f3f3;
	}
}
</style>
